//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import {
  Box,
  Button,
  Icon as ChakraIcon,
  Flex,
  HStack,
  List,
  ListItem,
  Text,
  useRadio,
  useRadioGroup,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import Pluralize from "pluralize";
import * as React from "react";
import { BsCheckLg } from "react-icons/bs";
import { renderOption } from "../../../../../../../home-tutoring/parent-flow/components/TeacherOptions";
import MobilePricingCard from "./MobilePricingCard";

export const PricingDetail = (props) => {
  const { children, ...rest } = props;
  return (
    <ListItem
      display="flex"
      alignItems="flex-start"
      fontWeight="medium"
      pr={{ base: "0", lg: "10" }}
      {...rest}
    >
      <ChakraIcon
        as={BsCheckLg}
        fontSize={{ base: "sm", lg: "lg" }}
        mt={1}
        mr={{ base: "2", lg: "4" }}
        color="blue.500"
      />

      <Text
        as="span"
        fontWeight="medium"
        fontSize={{ base: "sm", lg: "md" }}
        display="inline-block"
      >
        {children}
      </Text>
    </ListItem>
  );
};

const PopularGradient = (props) => (
  <Box
    top="0"
    left="0"
    width={"full"}
    h="2.5rem"
    position="absolute"
    roundedTop="3xl"
    roundedBottom={"0"}
    bgGradient="linear(to-b, #0054E533, transparent)"
    {...props}
  />
);

export const PriceDisplay = (props) => {
  const { currency, price = 0 } = props;
  return (
    <Flex w="100%" my={{ base: "3", lg: "5" }} fontWeight="medium">
      <Text fontSize={["2xl", "3xl"]} mr="2">
        {currency}
      </Text>
      <Text fontSize={["4xl", "48px"]} lineHeight="1" letterSpacing="tight">
        {price.toLocaleString()}
      </Text>
    </Flex>
  );
};

const PricingWrapper = (props) => {
  const { highlight, ...rest } = props;
  const popularStyles = {
    zIndex: 1,
    border: "none",
  };

  const styles = highlight ? popularStyles : null;
  return (
    <Box
      w="full"
      h="full"
      maxW="md"
      mx="auto"
      bg="white"
      px={["6", "10"]}
      pt="10"
      pb={{ base: "6", lg: "0" }}
      rounded="3xl"
      display={"flex"}
      flexDirection="column"
      justifyContent={"space-between"}
      position="relative"
      border="2px solid #EFF1F5"
      {...styles}
      {...rest}
    />
  );
};

export type PricingCardProps = {
  onClick: () => void;
  features: string[];
  duration?: string;
  lessons?: number;
  name: string;
  description: string;
  price: number;
  popular?: boolean;
  isLoading?: boolean;
  selectedCurrency: any;
  teacherNoOptions: string[];
  teacherStore: any;
  canChangeNoOfTutors?: boolean;
  separateTeacherInfo: any;
  teachingOptions: any;
  currentPlan: string;
};

export const PricingCard: React.FC<PricingCardProps> = (props) => {
  const {
    onClick,
    features,
    duration = "per month",
    lessons = 12,
    name,
    description,
    price,
    popular,
    isLoading,
    selectedCurrency,
    teacherNoOptions,
    teacherStore,
    canChangeNoOfTutors,
    // separateTeacherInfo,
    teachingOptions,
    currentPlan,
    ...rest
  } = props;
  const teacherSelectionInfo = renderOption(teachingOptions, true, true);
  const selectedOption = teacherSelectionInfo.find((i) => {
    if (!teacherStore.teacherOption) {
      return i;
    }

    return i.option.toLowerCase() === teacherStore.teacherOption.toLowerCase();
  });
  const canSelectTeacher =
    name.toLowerCase() === "standard" && teacherNoOptions.length >= 1;
  const [showBreakdown, setShowBreakdown] = React.useState(false);

  return (
    <Box
      order={{
        base: currentPlan === name.toLowerCase() ? "0" : "1",
        lg: popular ? "1" : "0",
      }}
    >
      <PricingWrapper highlight={popular} {...rest}>
        {popular && <PopularGradient />}
        <MobilePricingCard
          canSelectTeacher={canSelectTeacher}
          selectedOption={selectedOption}
          {...props}
        />
        <Box display={{ base: "none", lg: "block" }}>
          <Box
            borderBottom="1px solid #EFF1F5"
            mx={["-6", "-10"]}
            px={["6", "10"]}
            minH="9rem"
            pb="1rem"
          >
            <Box display={"flex"} alignItems={"center"}>
              <Text fontSize="xl" fontWeight="medium">
                {name} Plan
              </Text>
              {popular && (
                <Text
                  marginLeft={"1.5rem"}
                  color="blue.500"
                  fontFamily={"Shantell sans"}
                  fontWeight="semibold"
                  fontSize={"lg"}
                >
                  Most popular
                </Text>
              )}
            </Box>
            <Text fontSize="md" mt="2" color="gray.600" opacity={"0.7"}>
              {description}
            </Text>
          </Box>
          <Box
            minH={{
              base: "0",
              lg:
                canChangeNoOfTutors && teacherNoOptions.length >= 1
                  ? `23rem`
                  : "0",
            }}
          >
            <Box my="2rem">
              <PriceDisplay currency={selectedCurrency.symbol} price={price} />

              <Box
                display="inline-flex"
                mx="auto"
                fontSize="lg"
                fontWeight="regular"
                textTransform={"capitalize"}
                opacity="0.7"
              >
                {duration} ({Pluralize("lesson", lessons, true)})
              </Box>
            </Box>
            {canSelectTeacher && (
              <>
                <Box
                  pb={{ base: "1.5rem", lg: "0" }}
                  pt="1.5rem"
                  borderTop="1px solid #EFF1F5"
                  mx={["-6", "-10"]}
                  px={["6", "10"]}
                >
                  <Text opacity={"0.7"} textTransform="capitalize" mb="0.5rem">
                    Select teacher arrangement
                  </Text>
                  <SelectTutorOptions
                    options={teacherNoOptions}
                    defaultValue={teacherStore.teacherOption}
                    onTeacherNumberSelect={(o) => {
                      teacherStore.updateField({
                        teacherKind: o,
                      });
                    }}
                  />
                </Box>
                {selectedOption
                  ? selectedOption.jsx(showBreakdown, () =>
                      setShowBreakdown(!showBreakdown)
                    )
                  : null}
              </>
            )}
          </Box>
          <Box mx={["-6", "-10"]}>
            <Button
              minH="4rem"
              roundedTop="0"
              roundedBottom={"3xl"}
              fontWeight="bold"
              fontSize={"lg"}
              background={popular ? "blue.500" : "transparent"}
              textColor={popular ? "#fff" : "blue.500"}
              borderTop={popular ? "none" : "1px solid #EFF1F5"}
              mt="2"
              w="100%"
              isLoading={isLoading}
              loadingText="Processing"
              onClick={onClick}
              display="flex"
              justifyContent={"center"}
              _hover={{
                background: popular ? "blue.500" : "#EFF1F5",
                opacity: popular ? "0.6" : "1",
              }}
            >
              Book Lesson
            </Button>
          </Box>
        </Box>
        {/* </Box> */}
      </PricingWrapper>
      <Box maxW="md" mx="auto" display={{ base: "none", lg: "block" }}>
        <List stylePosition="outside" mt="3rem" opacity={"0.7"} spacing={4}>
          {features.map((feature, idx) => (
            <PricingDetail key={idx}>{feature}</PricingDetail>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export const SelectTutorOptions = ({
  defaultValue,
  options,
  onTeacherNumberSelect,
}: {
  options: string[];
  defaultValue: string;
  onTeacherNumberSelect: (name: string) => void;
}) => {
  const { getRootProps, getRadioProps } = useRadioGroup({
    name: "tutorType",
    defaultValue: defaultValue || options[0],
    onChange: onTeacherNumberSelect,
  });

  const group = getRootProps();
  return (
    <HStack
      {...group}
      mt="1rem"
      flexDirection={["column", "row"]}
      spacing={["0", options.length >= 2 ? "6" : "14"]}
      alignItems="flex-start"
    >
      {options.map((value, index) => {
        const radio = getRadioProps({ value });
        return (
          <SelectTutorOption key={value} {...radio} index={index}>
            {value}
          </SelectTutorOption>
        );
      })}
    </HStack>
  );
};

export const SelectTutorOption = (props: any) => {
  const { getInputProps, getCheckboxProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getCheckboxProps();

  return (
    <Box as="label">
      <input {...input} />
      <Box
        display={"flex"}
        alignItems={"center"}
        mt={[props.index === 0 ? "0" : "3", "0"]}
      >
        <Box
          {...checkbox}
          cursor="pointer"
          borderWidth="1px"
          borderRadius="md"
          background={"#EFF1F5"}
          border="1px solid #B9C0D4"
          width={{ base: "15px", lg: "25px" }}
          height={{ base: "15px", lg: "25px" }}
          rounded="full"
          _checked={{
            bg: "blue.500",
            color: "white",
            borderColor: "blue.600",
          }}
        />
        <Text
          textAlign="center"
          ml="0.5rem"
          fontSize={{ base: "sm", lg: "md" }}
        >
          {props.children.split(" ")[0]}
        </Text>
      </Box>
    </Box>
  );
};
